import { render, staticRenderFns } from "./ChallengeComingSoon.vue?vue&type=template&id=416d5c0f&scoped=true"
import script from "./ChallengeComingSoon.vue?vue&type=script&lang=ts"
export * from "./ChallengeComingSoon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d5c0f",
  null
  
)

export default component.exports